import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
const faqs = [{
  question: "Will my LinkedIn feed become overly promotional?",
  answer: "No. We focus on sharing high-quality, relevant content that adds value to your network. Our approach is designed to enhance your professional presence, not overwhelm it."
}, {
  question: "Is this allowed by LinkedIn?",
  answer: "We comply with LinkedIn regulations and are aware of the ever-changing algorithm, always keeping your account at a safe level of outreach. Moreover, your profile getting interactions with other users and having posts is a great way to increase your profile visibility with the LinkedIn algorithm. So it's actually good for your LinkedIn!"
}, {
  question: "What if I want to stop the service?",
  answer: "You can end participation at any time. We simply won't post or message on your behalf, and you keep any earnings up to that point according to our program terms."
}, {
  question: "How do I know you won't misuse my account?",
  answer: "We use secure, limited-access tools and never view or alter personal data. Our reputation depends on trust; we can't afford to jeopardize yours. Additionally, you'll have complete visibility on all activity in your account dashboard. Everything we do with the tools will be visible in your LinkedIn account when you log in."
}, {
  question: "What if someone from my network asks about these sponsored posts?",
  answer: "You can be transparent, or we can add a small disclosure if needed. We're flexible and can work with your comfort level to maintain authenticity."
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-white py-16" data-id="element-20">
      <div className="max-w-4xl mx-auto px-4" data-id="element-21">
        <h2 className="text-3xl font-bold text-center mb-12" data-id="element-22">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4" data-id="element-23">
          {faqs.map((faq, index) => <div key={index} className="border rounded-lg" data-id="element-24">
              <button className="w-full flex justify-between items-center p-4 text-left" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-25">
                <span className="font-semibold" data-id="element-26">{faq.question}</span>
                {openIndex === index ? <ChevronUp className="h-5 w-5 text-gray-500" data-id="element-27" /> : <ChevronDown className="h-5 w-5 text-gray-500" data-id="element-28" />}
              </button>
              {openIndex === index && <div className="p-4 pt-0 text-gray-600" data-id="element-29">{faq.answer}</div>}
            </div>)}
        </div>
      </div>
    </section>;
};